/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HotelBookingResponseStatus } from './HotelBookingResponseStatus';
import {
    HotelBookingResponseStatusFromJSON,
    HotelBookingResponseStatusFromJSONTyped,
    HotelBookingResponseStatusToJSON,
    HotelBookingResponseStatusToJSONTyped,
} from './HotelBookingResponseStatus';

/**
 * The response from a hotel booking request when an error occurs
 * @export
 * @interface HotelBookingResponseError
 */
export interface HotelBookingResponseError {
    /**
     * 
     * @type {number}
     * @memberof HotelBookingResponseError
     */
    statusCode: number;
    /**
     * 
     * @type {HotelBookingResponseStatus}
     * @memberof HotelBookingResponseError
     */
    status: HotelBookingResponseStatus;
    /**
     * 
     * @type {Error}
     * @memberof HotelBookingResponseError
     */
    error: Error;
    /**
     * 
     * @type {Array<Error>}
     * @memberof HotelBookingResponseError
     */
    subErrors?: Array<Error>;
}



/**
 * Check if a given object implements the HotelBookingResponseError interface.
 */
export function instanceOfHotelBookingResponseError(value: object): value is HotelBookingResponseError {
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function HotelBookingResponseErrorFromJSON(json: any): HotelBookingResponseError {
    return HotelBookingResponseErrorFromJSONTyped(json, false);
}

export function HotelBookingResponseErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): HotelBookingResponseError {
    if (json == null) {
        return json;
    }
    return {
        
        'statusCode': json['status_code'],
        'status': HotelBookingResponseStatusFromJSON(json['status']),
        'error': json['error'],
        'subErrors': json['sub_errors'] == null ? undefined : json['sub_errors'],
    };
}

export function HotelBookingResponseErrorToJSON(json: any): HotelBookingResponseError {
    return HotelBookingResponseErrorToJSONTyped(json, false);
}

export function HotelBookingResponseErrorToJSONTyped(value?: HotelBookingResponseError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_code': value['statusCode'],
        'status': HotelBookingResponseStatusToJSON(value['status']),
        'error': value['error'],
        'sub_errors': value['subErrors'],
    };
}

